module.exports = __webpack_public_path__ + "static/media/ratio.6789a4ff.png";